import { render, staticRenderFns } from "./MaskIcon.vue?vue&type=template&id=82f013ca&scoped=true"
import script from "./MaskIcon.vue?vue&type=script&lang=ts"
export * from "./MaskIcon.vue?vue&type=script&lang=ts"
import style0 from "./MaskIcon.vue?vue&type=style&index=0&id=82f013ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f013ca",
  null
  
)

export default component.exports